import type {AppPageProps} from "./Page.types";
import {AppContent} from "./Content";

export const AppPage = (props: AppPageProps) => {
  return (
    <AppContent pageTitle={props.pageTitle}
                className={props.className}
                contentClassName={props.contentClassName}
                style={props.style}>
      {props.children}
    </AppContent>
  );
};